// extracted by mini-css-extract-plugin
export var socketWrapper = "styles-module--socketWrapper--2vnhx";
export var socket = "styles-module--socket--13sry";